/**
 * @description Bandeau cookies
 */
(() => {
  // VARS
  const root = document.querySelector('body');
  const yellowStoneCookies = drupalSettings.yellowstone.cookies;
  const gaProperty = yellowStoneCookies.analytics; // ID de suivie GAnalytics
  const allCookies = yellowStoneCookies.list;  // Tous les cookies

  const cookiesBanner = () => {
    const banner = `<div class="cookies__shadow"></div>
                    <div class="cookies module shadow col-lg-4 col-md-8 col-sm-12" tabindex="1">
                      <div class="cookies__title">
                          <i class="list-group-item__icon btn-icon btn-icon-secondary btn-icon" data-icon="cookies"></i>
                          <h4>Cookies</h4>
                      </div>
                      <div class="cookies__content">
                          Ce site utilise des cookies pour assurer le bon fonctionnement et réaliser des statistiques de visite.
                      </div>
                      <div class="cookies__btn">
                        <button class="btn btn-primary icon icon-right align-self-start close" type="button" tabindex="8">
                            J'ai compris
                            <i data-icon="arrow" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>`;

    root.insertAdjacentHTML('beforeend', banner);
  };

  // FUNCTION
  const activeAnalytics = () => {
    (function(i, s, o, g, r, a, m) {
      i.GoogleAnalyticsObject = r;
      (i[r] =
        i[r] ||
        function() {
          (i[r].q = i[r].q || []).push(arguments);
        }),
        (i[r].l = 1 * new Date());
      (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(
      window,
      document,
      'script',
      'https://www.google-analytics.com/analytics.js',
      'ga'
    );
    ga('create', gaProperty, document.location.hostname);
    ga('send', 'pageview');
  };

  const activeAll = () => {
    activeAnalytics();
    allCookies.forEach(cookie => {
      const cookieName = cookie['id']
      activeCookie(cookieName); // name and number of days untill cookie expires
    })
  };

  const expirationDate = () => {
    var days = 395; // RGPD date expiration à 13 mois
    var date = new Date();
		date.setTime(date.getTime()+(days*24*60*60*1000));
		date.toGMTString();
    return date;
  }

  const activeCookie = (cookie) => {
    const expiration = expirationDate();
    const options = 'expires=' + expiration + ';path=/;secure;';
    document.cookie = cookie +'=true;' + options;
  }
 
  const cookies = () => {
    cookiesBanner();
  };

  /**
   * @description Fonction qui ferme la bannière en enregistrant le consentement
   */
  const closeCnil = e => {
    activeAll();
    document.querySelector('.cookies').remove();
    document.querySelector('.cookies__shadow').remove();
  };

  // initialise les fonctions permettant les différentes actions dans le bandeau (toggle, extend, closeCnil)
  // resize le bandeau 
  const setCookies = () => {
    const div = document.querySelector('.cookies') || null;

    if (div) {
      div.style.right = `calc(50% - ${div.offsetWidth / 2}px)`;

      root.querySelector(`.cookies`).addEventListener('click', e => {
          closeCnil(e);
      });
    }
  }

  // GO 🚀
  const init = () => {
    if (!document.cookie){
      cookies();  
      setCookies();
    }   
  };

  init();

  // Tag Google Analytics
  var _gaq = _gaq || [];
  _gaq.push(['_setAccount', gaProperty]);
  _gaq.push(['_trackPageview']);

  (function() {
    const ga = document.createElement('script');
    ga.type = 'text/javascript';
    ga.async = true;
    ga.src = `${
      document.location.protocol == 'https:' ? 'https://ssl' : 'http://www'
    }.google-analytics.com/ga.js`;
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ga, s);
  })();
})();
